module.exports = __webpack_public_path__ + "img/io.45750f7e.svg";